import { BaseController } from "../../../common/base/controller";

export class PdfViewerController extends BaseController {
	constructor(controllerService) {
		"ngInject";
		super({ controllerService });
	}

	$onChanges(changes) {
		if (changes.blob) {
			this.revokeObjectUrl();
			this.setObjectUrl(changes.blob.currentValue);
		}
	}

	$onDestroy() {
		this.revokeObjectUrl();
	}

	setObjectUrl(blob) {
		if (!blob) {
			this.pdfUrl = null;
			return;
		}

		this.objectUrl = this.$window.URL.createObjectURL(blob);
		this.pdfUrl = encodeURIComponent(this.objectUrl);
	}

	revokeObjectUrl() {
		if (this.objectUrl) {
			this.$window.URL.revokeObjectURL(this.objectUrl);
			this.objectUrl = null;
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/common/ui/pdfViewer/pdfViewer.controller.js